import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-why',
  templateUrl: './why.component.html',
  styleUrls: ['./why.component.less']
})
export class WhyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
